module.exports = __webpack_public_path__ + "static/media/YB5M18_4.ce1ed743.jpg";